import { ProjectService } from '../../services/project.service';
import { AuthService } from '../../services/auth.service';
import { ProjectOption } from '../../interfaces/project';

/**
 * P1-A: one options fetch per page load shared by every picker on it (a journal grid renders one per line).
 * The options are filtered per caller (D-P1-3), so the cache is keyed by institution AND signed-in user,
 * and AuthContext clears it on logout, impersonate and exit-impersonation.
 */
let cache: { key: string; promise: Promise<ProjectOption[]> } | null = null;

// `?.()` only because many suites mock AuthService with a partial factory; the app always has getCurrentUser.
const cacheKey = (institution: string) => `${institution}|${AuthService.getCurrentUser?.()?.username ?? ''}`;

export const loadProjectOptions = (institution: string): Promise<ProjectOption[]> => {
    const key = cacheKey(institution);
    if (!cache || cache.key !== key) {
        const promise = ProjectService.options().catch(() => {
            if (cache?.key === key) cache = null; // let the next mount retry
            return [] as ProjectOption[];
        });
        cache = { key, promise };
    }
    return cache.promise;
};

/** Forget the shared option list (identity change, or after a project is created / its status changes). */
export const resetProjectOptionsCache = () => { cache = null; };
